export const formatTelephone = (value:string) => {
    let aux = value.replace(/\D+/g, '');
    if (aux.length === 3) return aux.replace(/(\d{2})/, '($1) ');
    if (aux.length > 3 && aux.length < 8) return aux.replace(/(\d{2})(\d*)/, '($1) $2');
    if (aux.length >= 8 && aux.length < 11) return aux.replace(/(\d{2})(\d{4})(\d*)/, '($1) $2-$3');
    return aux.replace(/(\d{2})(\d{5})(\d*)/, "($1) $2-$3");
}

export const formatTelephoneReverse = (value:string) => {
    return  value.replace(/\D+/g, "");
}

export const formatCEP = (value:string) => {
    return  value.replace(/(\d{5})(\d{3})/, "$1-$2");
}